import { NodoEstructuraJerarquica } from './nodo-estructura-jerarquica.model';
import { EstructuraJerarquica } from './estructura-jerarquica.model';
import { TipoEvaluacion } from './tipo-evaluacion.model';
import { Escenario } from './escenario.model';
import { Usuario } from './usuario.model';
import { Objetivo } from './objetivo.model';
import { DimensionRiesgo} from './dimension-riesgo.model';
import { ObjetivoRiesgo} from './objetivo-riesgo.model';
import { ControlSugerido} from './control-sugerido.model';
import { Kri} from './kri.model';
import { MedidaDeContingencia} from './medida-de-contingencia.model';


export class Evaluacion
{
    id: number;
    nombre: string;
    version: number;
    tipo: TipoEvaluacion;
    estructuraJerarquica: EstructuraJerarquica;
    nodoEstructuraJerarquica: NodoEstructuraJerarquica;
    escenario: Escenario;
    owner: Usuario;
    creador :Usuario;
    fechaCreado: Date;
    fechaInicio: Date;
    fechaFin: Date;
    estado: string;
    objetivos: Objetivo[];
    usuarios: Usuario[];
    dimensiones: DimensionRiesgo[];
    riesgos: ObjetivoRiesgo[];
    controlesSugeridos: ControlSugerido[];
    kris: Kri[];
    medidasDeContingencia: MedidaDeContingencia[];


    /**
     * Constructor
     *
     * @param evaluacion
     */
    constructor(evaluacion)
    {
        {
            this.id = evaluacion.id || null;
            this.nombre = evaluacion.nombre || '';
            this.version= evaluacion.version || 0;
            this.tipo = evaluacion.tipo || null;
            this.estructuraJerarquica = evaluacion.estructuraJerarquica || null;
            this.nodoEstructuraJerarquica= evaluacion.nodoEstructuraJerarquica || null;
            this.escenario = evaluacion.escenario || null;
            this.owner = evaluacion.owner || null;
            this.creador= evaluacion.creador || null;
            this.fechaCreado= evaluacion.fechaCreado || new Date();
            this.fechaInicio =evaluacion.fechaInicio || null;
            this.fechaFin = evaluacion.fechaFin || null;
            this.estado = evaluacion.estado || 'PRE_INICIADO';
            this.objetivos = evaluacion.objetivos || [];
            this.usuarios = evaluacion.usuarios || [];
            this.dimensiones = evaluacion.dimensiones || [];
            this.riesgos = evaluacion.riesgos || [];
            this.controlesSugeridos = evaluacion.controlesSugeridos || [];
            this.kris = evaluacion.kris || [];
            this.medidasDeContingencia = evaluacion.medidasDeContingencia || [];



        }
    }
}
